interface Elements {
  dialog?: HTMLDialogElement
  title?: HTMLParagraphElement
  message?: HTMLInputElement
}

export class HelloAlert extends HTMLElement {
  static observedAttributes = ['title', 'message', 'open']
  #el: Elements = {}
  #mount: HTMLElement | null = null

  constructor() {
    super()
    // no shadowRoot/shadow DOM to enable tailwindcss
    this.#mount = document.body
  }

  connectedCallback() {
    this.#render()
  }

  attributeChangedCallback() {
    this.#render()

    const isOpen = JSON.parse(this.getAttribute('open') || '{}')
    if (!isOpen) return this.remove()

    if (this.#el.title) {
      this.#el.title.innerText = this.getAttribute('title') || 'HelloAlert'
    }
    if (this.#el.message) {
      this.#el.message.value = this.getAttribute('message') || 'HelloAlert message'
    }
  }

  #render() {
    // do not render again if already given
    if (this.#el.dialog) return

    const dialog = document.createElement('dialog')
    dialog.classList.add('modal')
    dialog.id = 'hello-alert-1'
    dialog.dataset.testid = 'hello-alert'
    dialog.innerHTML = `
      <div class="modal-box">
        <h3 class="text-lg font-bold" >Native web component</h3>
        <p class="py-4"></p>
        <div>
          <label class="label">
            <span>Stimulus output</span>
            <input type="text" placeholder="enter text" class="input" />
          </label>
        </div>
        <button type="button" class="btn btn-success">OK</button>
      </div>
    `
    this.#mount?.appendChild(dialog)
    this.#el.title = dialog.querySelector('p') ?? undefined
    this.#el.message = dialog.querySelector('input') ?? undefined
    console.log('[render]', { in: dialog.querySelector('input') })
    this.#el.dialog = dialog
    this.#setupEventHandlers()
    // Use requestAnimationFrame to ensure dialog is fully rendered before showing
    requestAnimationFrame(() => this.#showDialog())
  }

  #setupEventHandlers() {
    console.log('[setupEventHandlers]', { btn: this.#mount?.querySelector('button') })
    this.#el.dialog?.querySelector('button')?.addEventListener('click', () => this.#closeDialog())
    this.#el.dialog?.addEventListener('close', (event) => this.#onDialogClose(event))
    this.#el.message?.addEventListener('input', (event) => {
      const target = event.target as HTMLInputElement
      this.dispatchEvent(new CustomEvent('input', { bubbles: true, composed: true, detail: { value: target.value } }))
    })
  }

  #showDialog() {
    this.#el.dialog?.showModal()
  }

  #closeDialog() {
    this.#el.dialog?.close('ok')
  }

  #onDialogClose(_event: Event) {
    this.dispatchEvent(new CustomEvent('close'))
  }

  disconnectedCallback() {
    // Note: With arrow function in addEventListener, we can't easily remove specific listeners
    // The dialog will be removed from DOM anyway, so this cleanup is optional
  }
}

customElements.define('hello-alert', HelloAlert)
